if (!customElements.get("product-images")) {
  class ProductImages extends HTMLElement {
    constructor() {
      super();
    }

    handleVariantChange(event) {
      if(!event.detail.variantId) return;

      const foundIndex = Array.from(this.images).findIndex(image => image.getAttribute('js-variants').includes(event.detail.variantId));
      const index = foundIndex === -1 ? 0 : foundIndex;
      
      if(!index) return;

      this.updateActiveImage(index);
    }

    updateActiveImage(index) {
      const image = this.querySelector(".is-active");
      if (!image) return;

      image.classList.remove("is-active");
      const newActive = this.images[index];
      newActive.classList.add("is-active");

      const lazySrc = newActive.getAttribute("js-src");
      if (lazySrc && !newActive.getAttribute("src")) {
        newActive.src = lazySrc;
      }

      const lazySrcset = newActive.getAttribute("js-srcset");
      if (lazySrcset && !newActive.getAttribute("srcset")) {
        newActive.srcset = lazySrcset;
      }

      const lazySizes = newActive.getAttribute("js-sizes");
      if (lazySizes && !newActive.getAttribute("sizes")) {
        newActive.sizes = lazySizes;
      }
    }

    handleClick(event) {
      const button = event.target.closest("button");
      if (!button) return;

      const action = button.getAttribute("js-action");
      if (!action) return;

      event.preventDefault();
      event.stopPropagation();

      this.activeIndex = this.activeIndex + Number(action);
      if (this.activeIndex > this.maxIndex) this.activeIndex = 0;
      if (this.activeIndex < 0) this.activeIndex = this.maxIndex;

      this.updateActiveImage(this.activeIndex);
    }

    connectedCallback() {
      this.activeIndex = 0;
      this.images = this.querySelectorAll("img");
      this.maxIndex = this.images.length - 1;
      this.addEventListener("click", this.handleClick.bind(this));
      this.addEventListener("variant:change", this.handleVariantChange.bind(this));
    }
  }

  customElements.define("product-images", ProductImages);
}
